export default __webpack_public_path__ + "static/media/sidebarOpenArrow.0b113273.svg";